/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const MobileApp = props => (
  <svg viewBox="0 0 384 512" width="1em" height="1em" {...props}>
    <path
      fill="currentColor"
      d="M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    />
  </svg>
);
export default extendIcon(MobileApp);
